(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cuddels-newest-products"] && !Shopify.designMode) return;
  try {
    
function loadCuddelsNewest(scope){scope.querySelectorAll('[data-cn-new]').forEach(root=>{const status=root.querySelector('[data-cn-load]');if(!status||root.dataset.loading)return;root.dataset.loading='true';const base=window.Shopify?.routes?.root||'/';const url=new URL(base+'collections/all',location.origin);url.searchParams.set('sort_by','created-descending');url.searchParams.set('section_id','cuddels-newest-products');fetch(url).then(r=>{if(!r.ok)throw Error();return r.text()}).then(html=>{const doc=new DOMParser().parseFromString(html,'text/html');const grid=doc.querySelector('.cn-grid');if(!grid||!grid.children.length)throw Error();status.replaceWith(grid);}).catch(()=>{status.textContent='';const link=document.createElement('a');link.href=url.pathname+'?sort_by=created-descending';link.textContent='Neueste Produkte entdecken →';status.append(link);});});}
loadCuddelsNewest(document);
document.addEventListener('shopify:section:load',e=>loadCuddelsNewest(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cuddels-recently-viewed')) {
  customElements.define('cuddels-recently-viewed', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const key = 'cuddels.recently-viewed.v1';
      const valid = value => {
        if (!Array.isArray(value)) return [];
        const seen = new Set();
        return value.filter(item => {
          if (!item || !/^\d+$/.test(String(item.id)) || typeof item.url !== 'string') return false;
          try {
            const url = new URL(item.url, location.origin);
            if (url.origin !== location.origin || !/\/products\/[^/]+$/.test(url.pathname) || seen.has(String(item.id))) return false;
            seen.add(String(item.id));
            return true;
          } catch { return false; }
        }).slice(0, 20);
      };
      let history = [];
      try { history = valid(JSON.parse(localStorage.getItem(key) || '[]')); } catch {}
      const previous = history.filter(item => String(item.id) !== this.dataset.productId);
      try { localStorage.setItem(key, JSON.stringify([{id: this.dataset.productId, url: this.dataset.productUrl}, ...previous].slice(0, 20))); } catch {}
      if (!previous.length) return;
      const load = async () => {
        const cards = await Promise.all(previous.slice(0, Number(this.dataset.limit) || 4).map(async item => {
          try {
            const url = new URL(item.url, location.origin);
            url.search = '';
            url.searchParams.set('section_id', 'related-products');
            const response = await fetch(url.href);
            if (!response.ok) return null;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            return html.querySelector('template[data-crv-card]')?.content.querySelector('li') || null;
          } catch { return null; }
        }));
        if (!this.isConnected) return;
        const list = this.querySelector('[data-crv-list]');
        cards.filter(Boolean).forEach(card => list.append(document.importNode(card, true)));
        this.hidden = !list.children.length;
        window.CuddelsWishlist?.refresh();
      };
      if ('IntersectionObserver' in window) {
        const sentinel = this.parentElement;
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
        }, {rootMargin: '800px'});
        observer.observe(sentinel);
      } else { load(); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class StickySimpleHeader extends HTMLElement {
    constructor() {
      super();
    
      const header = document.querySelector('.enable-simple-sticky-header'); 
      header.parentElement.classList.add('sticky-simple-header');

      window.addEventListener('scroll', this.checkIfSticky.bind(this));
    }
    
    checkIfSticky() {
      if (window.innerWidth > 1024) return;

      const header = document.querySelector('.enable-simple-sticky-header'); 
      const headerRect = header.parentElement.getBoundingClientRect();
      const searchFeaturedBar = document.querySelector('.search__featured-bar');

      if (headerRect.top <= 0) {
        searchFeaturedBar?.classList.add('move');
      } else {
        searchFeaturedBar?.classList.remove('move');
      }
    }
  }

  customElements.define('sticky-simple-header', StickySimpleHeader);


  } catch(e) { console.error(e); }
})();
})();
